module.exports = __webpack_public_path__ + "static/media/message_sent.b224cf6b.wav";